var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRiskassociate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2546_3243",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.9326 81.9326V18.0674H18.0674V81.9326H81.9326Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.134766
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2546_3243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.463 70.8502L53.8324 24.7245C52.1291 21.7744 47.8709 21.7744 46.1676 24.7245L19.537 70.8502C17.8337 73.8004 19.9628 77.4881 23.3693 77.4881H76.6306C80.0372 77.4881 82.1662 73.8004 80.463 70.8502Z",
    stroke: "#344054",
    strokeWidth: 2.02148,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0039 37.0509L73.8791 71.476H57.0117",
    stroke: "#344054",
    strokeWidth: 2.02148,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9874 71.476H26.1191L50.0012 30.1109L51.9001 33.4",
    stroke: "#344054",
    strokeWidth: 2.02148,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0063 69.4719C53.0063 71.1322 51.6604 72.478 50.0003 72.478C48.34 72.478 46.9941 71.1322 46.9941 69.4719C46.9941 67.8118 48.34 66.4659 50.0003 66.4659C51.6604 66.4659 53.0063 67.8118 53.0063 69.4719Z",
    stroke: "#344054",
    strokeWidth: 2.02148,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0522 62.4578H48.9454C48.4125 62.4578 47.9728 62.0407 47.9448 61.5085L47.0483 44.4742C47.0182 43.901 47.4748 43.4196 48.0489 43.4196H51.9487C52.5228 43.4196 52.9795 43.901 52.9494 44.4742L52.0528 61.5085C52.0248 62.0407 51.5852 62.4578 51.0522 62.4578Z",
    stroke: "#344054",
    strokeWidth: 2.02148,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRiskassociate);
export default __webpack_public_path__ + "static/media/icon_riskassociate.e70052e85fe6bd4d3ddd88e6c5ad8542.svg";
export { ForwardRef as ReactComponent };